export const breakText = (
  text: string,
  length: number,
  requiredLength: number
) => {
  if (length <= requiredLength) {
    return text;
  }
  return `${text.slice(0, requiredLength)}...`;
};
